import axios from 'axios'
import qs from 'qs'
import store from '../store'
import router from "../router";
import { mapState } from 'vuex'
const HOST = BASEURL

import {
  Message
} from 'element-ui'

const defaultAxios = axios.create({
  baseURL: '',
  timeout: 600000,
  withCredentials: false
})

defaultAxios.interceptors.request.use((config) => {
  const vuex = JSON.parse(localStorage.getItem('vuex'))
  if(vuex){
    let path = router.history.current.path
    if(vuex.webUserInfo && path.indexOf('admin') < 0){
      config.headers['Authorization'] = `Bearer ${vuex.webUserInfo.token}`
    }else{
      // config.headers['Authorization'] = `Bearer ${vuex.adminUserInfo.token}`
    }

  }
  return config
})

defaultAxios.interceptors.response.use((response) => {
  if(response.data.token){
    return response.data
  }
  const {  code,message } = response.data
  if (code === 200 || code === 0) {
    //请求成功,返回请求体的data
    return response.data
  } else if (code === 401) {
    const originalRequest = response.config; // 记录原始请求配置
    let path = router.history.current.path
    if(path && path.indexOf('admin') < 0){
      store.dispatch('clearAdminUserInfo')
      router.replace('/admin')
      return Message.error('登录失效，请重新登录')
    }else{
      //登录信息失效，token过期，重新刷新token
      const vuex = JSON.parse(localStorage.getItem('vuex'))
      const postData = { };
      axios.post(HOST+ '/api/Login/refreshToken', postData,{
        headers: {
          'Authorization': `Bearer ${vuex.webUserInfo.token}`
        }}).then(res => {
        // 请求成功时处理响应
        if (res.code === 200) {
          const newToken = res.data.token;
          store.dispatch('updateWebToken', newToken)  //替换更新新的token
          originalRequest.headers['Authorization'] = `Bearer ${newToken}`;    // 更新原始请求的 Authorization 头部，
          return defaultAxios.request(originalRequest);   //并重试原请求
        }else{
          store.dispatch('clearWebUserInfo')
          router.replace('/')
          return Message.error('登录失效，请重新登录')
        }
      })
        .catch(error => {
          // 请求失败时处理错误
          // console.error('Error:', error);
        });
    }
  }else{
    return Message.error(message)
  }
})

export const get = (url, params, config = {}) => {
  return new Promise((reslove, reject) => {
    let httpOption = {
      method: 'GET',
      url,
      params,
      ...config
    }
    defaultAxios(httpOption).then(response => {
      reslove(response)
    }).catch(error => {
      reject(error)
    })
  })
}

export const post = (url, data, config = {}) => {
  return new Promise((reslove, reject) => {
    if (config.form) {
      let headers = {}
      data = qs.stringify(data, {
        allowDots: true
      })
      headers['Content-Type'] = 'application/x-www-form-urlencoded'
      config.headers = Object.assign(headers, config.headers)
    }
    let httpOption = {
      method: 'POST',
      url,
      data,
      ...config
    }
    defaultAxios(httpOption).then(response => {
      reslove(response)
    }).catch(error => {
      reject(error)
    })
  })
}

export const del = (url, params, config = {}) => {
  return new Promise((reslove, reject) => {
    let httpOption = {
      method: 'DELETE',
      url,
      params,
      ...config
    }
    defaultAxios(httpOption).then(response => {
      reslove(response)
    }).catch(error => {
      reject(error)
    })
  })
}

export const put = (url, data, config = {}) => {
  return new Promise((reslove, reject) => {
    let httpOption = {
      method: 'GET',
      url,
      data,
      ...config
    }
    defaultAxios(httpOption).then(response => {
      reslove(response)
    }).catch(error => {
      reject(error)
    })
  })
}
function encodeUtf8(text) {
  const code = encodeURIComponent(text);
  const bytes = [];
  for (var i = 0; i < code.length; i++) {
    const c = code.charAt(i);
    if (c === '%') {
      const hex = code.charAt(i + 1) + code.charAt(i + 2);
      const hexVal = parseInt(hex, 16);
      bytes.push(hexVal);
      i += 2;
    } else bytes.push(c.charCodeAt(0));
  }
  return bytes;
}

export const postForm = (url, data, config = {}) => {
  return new Promise((reslove, reject) => {
    // 读取文件内容为Blob
    const reader = new FileReader();
    reader.readAsArrayBuffer(data.file);
    reader.onload = function(e) {
      const blob = new Blob([e.target.result], { type: data.file.type });
      let file_name = encodeURIComponent(data.file.name);
      let httpOption = {
        method: 'POST',
        url,
        data: blob,
        headers: {
          "Content-Type": data.file.type,
          'Content-Disposition' : `attachment;filename=${file_name}`,
        },
        ...config // Merge other options from config if needed
      };

      defaultAxios(httpOption).then(response => {
        reslove(response)
      }).catch(error => {
        reject(error)
      })

    }
  });
};

